/** @jsx jsx */
/* eslint-disable no-use-before-define */

import {Fragment} from 'react'
import {jsx, css} from '@emotion/core'
import {Flyout} from '../flyout'
import {mediaQueries} from '../media-queries'


export default ({label, align, info, htmlFor}) => (
    <Fragment>
        <div className="vertical-offset-xxs"></div>
        {!info && <h5
            style={{display:'inline'}}
            htmlFor={htmlFor}
            css={[align==='right' && textAlignRight ]}
            >{label}</h5>}

        {info && <Flyout
            label={label}
            html={info}
            className="btn-label btn-flyout tiny-header"
            labelAttrs={{
                htmlFor,
                css: [align==='right' && textAlignRight ]
            }}/>}
    </Fragment>
)

const textAlignRight = css`
    ${mediaQueries.notXs} { text-align: right }
`


// WEBPACK FOOTER //
// ./src/twd/fields/label.js